import { useDispatch } from 'react-redux';
import { getCategoryList, setActiveCategory, clearState } from 'actions/categoryActions';

export function usePrefixCategoryActions() {
  const dispatch = useDispatch();

  const getCategoryListAction = () => dispatch(getCategoryList());

  const setActiveCategoryAction = (category) => dispatch(setActiveCategory(category));

  const clearStateAction = () => dispatch(clearState());

  return {
    getCategoryListAction,
    setActiveCategoryAction,
    clearStateAction
  };
}
